import { SettingsGroup } from "./types";

/** Sales and Catering (productId = 5) — add group definitions here. */
export const sncSettingsGroups: SettingsGroup[] = [];
